"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
let ButtonMenuLineComponent = 
/**
 * Component for a button menu line
 * @class ButtonMenuLineComponent
 * @classdesc Component for a button menu line
 * @author insite-gmbh
 */
class ButtonMenuLineComponent {
    constructor() {
        this.select = new core_1.EventEmitter();
    }
    /**
     * This method will be called by the menuButton component when the item action was successfully applied.
     * @method onSelected
     * @param {IMenuItem} entry This is a menu entry.
     */
    onSelected(entry) {
        if (entry == null)
            return;
        //If entry is a parent, call select on the menu, to update the submenu. 
        if (entry.parent == null) {
            this.select.emit(entry);
        }
        //Update selections in the current line
        this.buttons.forEach(b => b.isSelected = b == entry);
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], ButtonMenuLineComponent.prototype, "buttons", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ButtonMenuLineComponent.prototype, "select", void 0);
ButtonMenuLineComponent = __decorate([
    core_1.Component({
        selector: 'button-menu-line',
        templateUrl: './@inax/buttonMenuUi/src/buttonMenuLine/buttonMenuLine.component.html',
        styleUrls: ['./@inax/buttonMenuUi/src/buttonMenuLine/buttonMenuLine.component.css']
    })
], ButtonMenuLineComponent);
exports.ButtonMenuLineComponent = ButtonMenuLineComponent;
